import { ArrowRight, Rocket, GraduationCap, Lightbulb, Building2, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { SEO } from '../components/SEO';

const starterProfiles = [
  { icon: GraduationCap, label: 'Étudiants', description: 'Projets de fin d\'études, associations étudiantes...' },
  { icon: Lightbulb, label: 'Jeunes entrepreneurs', description: 'Premiers mois d\'activité, budget serré...' },
  { icon: Building2, label: 'Entreprises locales innovantes', description: 'Start-ups, projets à impact positif...' },
];

export default function DecollagePage() {
  return (
    <main className="pb-0" data-testid="decollage-page">
      <SEO
        title="Offre Décollage – Site web professionnel à 999€ | Axeris Labs"
        description="Offre spéciale pour étudiants, jeunes entrepreneurs et start-ups. Un site professionnel complet et personnalisé à 999€ maximum."
        path="/decollage"
      />

      <section className="relative pt-32 pb-20 overflow-hidden">
        <div 
          className="absolute inset-0 opacity-[0.04]"
          style={{ background: 'radial-gradient(ellipse 80% 60% at 50% 0%, #10b981, transparent)' }}
        />
        <div className="absolute inset-0 noise pointer-events-none" />

        <div className="container-main relative z-10">
          <nav className="flex items-center gap-2 text-sm text-muted-foreground mb-10 animate-fade-in">
            <Link to="/tarifs" className="hover:text-foreground transition-colors">Tarifs</Link>
            <span>/</span>
            <span className="text-foreground font-medium">Offre Décollage</span>
          </nav>

          <Card className="border-2 border-emerald-500/30 bg-gradient-to-br from-emerald-500/5 to-teal-500/5 overflow-hidden">
            <CardContent className="p-8 md:p-12">
              <div className="grid lg:grid-cols-2 gap-12 items-center">
                {/* Left side - Info */}
                <div>
                  <div className="flex items-center gap-3 mb-6">
                    <div className="p-3 rounded-xl bg-emerald-500/10">
                      <Rocket className="h-8 w-8 text-emerald-500" />
                    </div>
                    <div>
                      <h2 className="text-3xl sm:text-4xl font-bold">Offre Décollage</h2>
                      <p className="text-muted-foreground">Parce que j'ai été à votre place</p>
                    </div>
                  </div>
                  
                  <p className="text-lg text-muted-foreground mb-6">
                    Je sais ce que c'est de démarrer avec un budget serré. C'est pourquoi je propose 
                    une offre spéciale pour ceux qui en ont vraiment besoin.
                  </p>

                  <div className="p-6 rounded-2xl bg-background/50 border border-emerald-500/20 mb-8">
                    <div className="flex items-baseline gap-2 mb-2">
                      <span className="text-4xl font-black text-emerald-500">999€</span>
                      <span className="text-muted-foreground">maximum</span>
                    </div>
                    <p className="text-muted-foreground">
                      Pour un site professionnel complet, vraiment personnalisé, sans limite de pages ou de fonctionnalités arbitraire.
                    </p>
                  </div>

                  <div className="space-y-4">
                    {starterProfiles.map((profile) => (
                      <div key={profile.label} className="flex items-start gap-4">
                        <div className="p-2 rounded-lg bg-emerald-500/10 shrink-0">
                          <profile.icon className="h-5 w-5 text-emerald-500" />
                        </div>
                        <div>
                          <div className="font-semibold">{profile.label}</div>
                          <div className="text-sm text-muted-foreground">{profile.description}</div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>

                {/* Right side - Philosophy */}
                <div className="bg-background/80 rounded-2xl p-8 border border-border">
                  <h3 className="text-xl font-bold mb-4">Ma philosophie</h3>
                  <div className="space-y-4 text-muted-foreground">
                    <p>
                      <strong className="text-foreground">Pas de questions sur le nombre de pages.</strong><br />
                      On discute de votre projet, de ce dont vous avez besoin, et on trouve ensemble la meilleure solution.
                    </p>
                    <p>
                      <strong className="text-foreground">Pas de fonctionnalités bridées.</strong><br />
                      Vous avez besoin d'un formulaire de contact, d'un blog, d'une galerie ? On le fait.
                    </p>
                    <p>
                      <strong className="text-foreground">Un vrai échange humain.</strong><br />
                      Je regarde votre situation et je fais ce que je peux pour vous aider à démarrer.
                    </p>
                    <p className="text-sm italic border-t border-border pt-4 mt-6">
                      Évidemment, si le projet devient vraiment très complexe (e-commerce avec 500 produits, 
                      fonctionnalités sur-mesure avancées...), le tarif peut être ajusté. Mais on en discute 
                      toujours ensemble, en toute transparence.
                    </p>
                  </div>
                  <a href="/tarifs#contact" className="block mt-6">
                    <Button className="w-full bg-emerald-500 hover:bg-emerald-600 text-white">
                      Me parler de votre projet
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </Button>
                  </a>
                </div>
              </div>
            </CardContent>
          </Card>

          <div className="text-center mt-12">
            <Link to="/tarifs">
              <Button variant="outline" className="rounded-full px-8 py-4 font-bold">
                <ArrowLeft className="mr-2 h-4 w-4" />
                Retour aux tarifs
              </Button>
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
